<div class="h-full w-fit rounded-lg border border-base-content/20 p-4">
  <div class="flex justify-between">
    <div class="mr-8">
      @if (paymentMethod.payment_type === 'bank') {
        <div class="mb-2 flex items-center">
          <span class="h-6 w-6"><app-building-icon></app-building-icon></span>
          <p class="ml-2 text-sm">
            {{ bankAccountTypeLabel(paymentMethod) }}
            <span class="ml-2">•••• {{ paymentMethod.last_4_digits }}</span>
          </p>
        </div>
      } @else {
        <div class="mb-2 flex items-center">
          @if (paymentMethod.card_type === 'Visa') {
            <app-visa-icon></app-visa-icon>
          } @else if (paymentMethod.card_type === 'MasterCard') {
            <app-mastercard-icon></app-mastercard-icon>
          } @else if (paymentMethod.card_type === 'AmericanExpress') {
            <app-american-express-icon></app-american-express-icon>
          } @else if (paymentMethod.card_type === 'Discover') {
            <app-discover-icon></app-discover-icon>
          } @else if (paymentMethod.card_type === 'JCB') {
            <app-jcb-icon></app-jcb-icon>
          } @else if (paymentMethod.card_type === 'DinersClub') {
            <app-diners-club-icon></app-diners-club-icon>
          } @else {
            <p class="text-lg">{{ paymentMethod.card_type }}</p>
          }
          <p class="ml-4 text-sm">•••• {{ paymentMethod.last_4_digits }}</p>
        </div>
        <p class="text-sm">Exp: {{ paymentMethod.card_expiration }}</p>
      }
      <p class="mt-2 text-sm">Billing Address:</p>
      <p class="text-sm" [innerHTML]="formattedAddress(paymentMethod)"></p>
    </div>
    <div class="mb-auto flex flex-col space-y-2">
      @if (paymentMethod.is_default) {
        <div class="badge badge-primary text-right text-base italic">
          Default
        </div>
      }
      @if (paymentMethod.is_api_default && showAPIDefault) {
        <div class="badge badge-secondary text-right text-base italic">
          API default
        </div>
      }
      @if (canManagePaymentMethods) {
        @if (!paymentMethod.is_default) {
          <button
            class="btn btn-primary btn-sm"
            (click)="setDefault.emit(paymentMethod)"
            [disabled]="settingDefaultMethod"
          >
            Set Default
          </button>
        }
        @if (!paymentMethod.is_api_default && showAPIDefault) {
          <button
            class="btn btn-secondary btn-sm"
            (click)="setApiDefault.emit(paymentMethod)"
            [disabled]="settingDefaultMethod"
          >
            Set API default
          </button>
        }
        @if (!paymentMethod.is_default && !paymentMethod.is_api_default) {
          <button
            class="btn btn-error btn-sm"
            (click)="deleteMethod.emit(paymentMethod)"
            [disabled]="settingDefaultMethod"
          >
            Remove
          </button>
        }
      }
    </div>
  </div>
</div>
